import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { JournalFileType } from 'app/shared/enums/journal-file-type.enum';
import { JournalNotificationCardModel } from './journal-notification-card.model';
import { JobNotificationCardComponent } from '../job-notification-card.component';
import { PrintActionButtonsComponent } from '../../../action-buttons/print-action-buttons/print-action-buttons.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-journal-notification-card',
  styleUrls: ['./journal-notification-card.component.scss'],
  templateUrl: './journal-notification-card.component.html',
  imports: [JobNotificationCardComponent, PrintActionButtonsComponent],
})
export class JournalNotificationCardComponent {
  @Output() public closeEvent = new EventEmitter<void>();
  @Output() public downloadJournalFecButtonEvent = new EventEmitter<void>();
  @Output() public downloadJournalPdfButtonEvent = new EventEmitter<void>();
  @Output() public downloadJournalSpreadsheetButtonEvent = new EventEmitter<void>();
  @Input() public journalNotificationCard: JournalNotificationCardModel;
  @Output() public openJournalPdfButtonEvent = new EventEmitter<void>();
  public journalFileTypeFec = JournalFileType.Fec;
  public journalFileTypePdf = JournalFileType.Pdf;
  public journalFileTypeSpreadsheet = JournalFileType.Xlsx;

  public downloadJournalFecButtonClickedHandler(): void {
    this.downloadJournalFecButtonEvent.emit();
  }

  public downloadJournalPdfButtonClickedHandler(): void {
    this.downloadJournalPdfButtonEvent.emit();
  }

  public downloadJournalSpreadsheetButtonClickedHandler(): void {
    this.downloadJournalSpreadsheetButtonEvent.emit();
  }

  public onCloseClickedHandler(): void {
    this.closeEvent.emit();
  }

  public openJournalPdfButtonClickedHandler(): void {
    this.openJournalPdfButtonEvent.emit();
  }
}
